<div class="row mx-0">
  <div class="col-7 px-0 text-start">
    <h3>My Fax Queue</h3>
  </div>
  <div class="col-5 no-padding">
    <app-user-stats />
  </div>
</div>
@if (!loading) {
  <div>
    @if (inboundFaxes.length > 0) {
      <section>
        <app-pagination-header
          [label]="'faxes'"
          [paging]="paging"
          (pageSizeChange)="onPageSizeChange($event)"
          />
        <table class="table table-bordered table-hover">
          <thead class="table-dark">
            <tr>
              <th>CLIENT</th>
              <th>STATUS</th>
              <th class="text-nowrap">RECEIVED AT &#x25BC;</th>
              <th>FROM</th>
              <th class="text-center">PAGES</th>
              <th>PATIENT</th>
              <th>PRESCRIBER</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            @for (inboundFax of inboundFaxes; track inboundFax; let i = $index) {
              <tr>
                <td>{{ inboundFax.client.humanizedName }}</td>
                <td>{{ inboundFax.status | faxStatus }}</td>
                <td class="text-nowrap">{{ inboundFax.receivedAt | date: 'MM/dd/yyyy hh:mm a' }}</td>
                <td class="text-nowrap">
                  <fa-icon [icon]="['fas', 'fax']" size="sm" />
                  <app-phone-number [number]="inboundFax.callerNumber" [noValue]="'UNKNOWN CALLER'" />
                </td>
                <td class="text-center">{{ inboundFax.pages | number }}</td>
                <td><app-patient-name [patient]="inboundFax.patient" [showAlternateNames]=false /></td>
                <td><app-prescriber-name [provider]="inboundFax.provider" /></td>
                <td>
                  <ul class="nav">
                    <li class="nav-item"><a class="nav-link" href="#" (click)="download($event, inboundFax)"> DOWNLOAD </a></li>
                    <li class="nav-item">
                      <a class="nav-link" routerLink="/capture-admin/my-work/faxes/{{inboundFax.id}}" (click)="onViewClick(i)">
                        VIEW
                      </a>
                    </li>
                    <li class="nav-item">
                      <app-user-presence category="inboundFax" [targetId]="inboundFax.id" />
                    </li>
                  </ul>
                </td>
              </tr>
            }
          </tbody>
        </table>
        <app-pagination [paging]="paging" (pageChange)="onPageChange($event)" />
      </section>
    } @else {
      <section><p>It's time to face the fax, you're all caught up!</p></section>
    }
  </div>
} @else {
  <mat-spinner />
}
